
<script>
  import Vue2Datepicker from 'vue2-datepicker'
  import { parseDate } from 'vue2-datepicker/src/utils/index.js'
  import moment from 'moment';

  export default {
    extends: Vue2Datepicker,
    mounted: function() {
      var self = this;
      const input = this.$refs["input"]
      const buttonLabel = self.format === 'MM/DD/YYYY' ? 'Today' : 'Now';

      $( input ).dblclick(function(){
        const dateToSetDatePickerTo = self.format === 'MM/DD/YYYY' ? moment().format('MM/DD/YYYY')
                                                                   : moment();
        self.currentValue = self.format === 'MM/DD/YYYY' ? dateToSetDatePickerTo : dateToSetDatePickerTo._d;
        self.userInput = self.format === 'MM/DD/YYYY' ? dateToSetDatePickerTo : dateToSetDatePickerTo.format('HH:mm');
        self.updateDate(true);
      })


      $(this.$el).find('.mx-calendar').append(`<p class="text-center"><br/><a class="btn btn-primary today-button">${buttonLabel}</a></p>`)

      $(this.$el).find('.today-button').click(function(){
        const dateToSetDatePickerTo = self.format === 'MM/DD/YYYY' ? moment().format('MM/DD/YYYY')
                                                                   : moment();
        self.currentValue = self.format === 'MM/DD/YYYY' ? dateToSetDatePickerTo : dateToSetDatePickerTo._d;
        self.userInput = self.format === 'MM/DD/YYYY' ? dateToSetDatePickerTo : dateToSetDatePickerTo.format('HH:mm');
        self.updateDate(true)
      })
    },
    methods: {
      handleChange(event) {
        let value = event.target.value.trim();

        if(value.match(/\//g)) {
          if(value.match(/\//g).length === 1) {
            let newYear = moment().year();
            value = moment(  `${ value }/${ newYear }` ).format( 'MM/DD/YYYY' );
          } else {
            value = moment( value ).format( 'MM/DD/YYYY' );
          }
        }

        this.currentValue = value;
        this.userInput = value;

        if(this.editable && this.userInput !== null) {
          const calendar = this.$children[0]
          const checkDate = calendar.isDisabledTime
          if(!value) {
            this.clearDate()
            return
          }
          if(this.range) {
            const range = value.split(` ${this.rangeSeparator} `)
            if(range.length === 2) {
              const start = this.parseDate(range[0], this.format)
              const end = this.parseDate(range[1], this.format)
              if(start && end && !checkDate(start, null, end) && !checkDate(end, start, null)) {
                this.currentValue = [ start, end ]
                this.updateDate(true)
                this.closePopup()
                return
              }
            }
          } else {
            const date = this.parseDate(value, this.format)
            if(date && !checkDate(date, null, null)) {
              this.updateDate(true)
              this.closePopup()
              return
            }
          }
          this.$emit('input-error', value)
        }
      }
    }
  }
</script>
